module.exports = __webpack_public_path__ + "static/img/comment-no-data.37d6ae60.png";